import React from "react";
export default function () {
    return (
        <svg width="210" height="200" viewBox="0 0 210 200">
            <g>
                <g>
                    <path d="M34.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S5.4,99.8,8,104.5s10.7,5.4,18,1.6S36.9,95.4,34.2,90.7Z" />
                    <rect x="33.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M98.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S69.4,99.8,72,104.5s10.7,5.4,18,1.6S100.9,95.4,98.2,90.7Z" />
                    <rect x="97.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <rect x="33" y="23" width="130" height="10" />
            </g>
            <g>
                <g>
                    <path d="M162.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4,10.7,5.4,18,1.6S164.9,95.4,162.2,90.7Z" />
                    <rect x="161.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <g>
                    <path d="M199.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6s-10.9,10.7-8.3,15.4,10.7,5.4,18,1.6S201.9,95.4,199.2,90.7Z" />
                    <rect x="198.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <rect x="161" y="23" width="39" height="10" />
                <rect x="161" y="37" width="39" height="10" />
            </g>
        </svg>
    );
}
